import axios from "axios";
import { headers, jwt } from "./constants";
import * as yup from "yup";

export interface IValuationVariable {
  id?: string;
  name?: string;
  mask?: string;
  type?: string;
  placeholder?: string;
  sortOrder?: number;
}

export const valuationVariableSchema = yup.object().shape({
  name: yup.string().nullable().required("Name is required"),
});

export let list = async () => {
  let hasError = false;
  let response: any = await axios
    .get(process.env.REACT_APP_API_URL + "/valuationVariable/list/", {
      headers: headers,
    })
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { data: response.data, hasError };
};

export let get = async (id: string) => {
  let hasError = false;
  let response: any = await axios
    .get(process.env.REACT_APP_API_URL + "/valuationVariable/get/", {
      headers: headers,
      params: { id: id },
    })
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { data: response.data, hasError };
};

export let create = async (valuationVariable: IValuationVariable) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/valuationVariable/create",
      { data: valuationVariable },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};

export let update = async (valuationVariable: IValuationVariable) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/valuationVariable/update",
      { data: valuationVariable },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};

export let deleteOne = async (valuationVariable: IValuationVariable) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/valuationVariable/delete",
      { data: valuationVariable },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};
